export default __webpack_public_path__ + "static/media/reutilizar.e7b0d4e7.png";